module.exports = __webpack_public_path__ + "static/media/oketayo.caabaa26.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oketayo.jpeg
// module id = 49
// module chunks = 0